<div class="signup" >
  <div class="signup__intro">
    <!-- <div class="signup__switch">
      <label class="signup__switch-toggle">
        <input type="checkbox" checked>
        <span class="signup__switch-slider"></span>
      </label>
      Bill Annually Save 50%
    </div> -->
    <h2 class="signup__intro-title">Plans Available for Every Strategy</h2>
    <p class="signup__intro-text">Whether you are looking to start a new line of business, invest in an innovative
      marketing strategy, or evaluate your financial institution’s performance, Lakehouse Analytics will give you the
      data you need to make effective decisions.</p>
    <a class="signup__more" href="https://lakehouse-analytics.com/solutions/peer-comparison/"><svg
        class="icon signup__more-icon" viewBox="0 0 448 512">
        <path
          d="M77.25 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C175.6 444.9 183.8 448 192 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L77.25 256zM269.3 256l137.4-137.4c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25l160 160C367.6 444.9 375.8 448 384 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L269.3 256z" />
      </svg> Learn More</a>
  </div>
  <app-plan planType="BundleYearly" [highlighted]="true"></app-plan>
  <app-plan planType="PeerComparisonStandard" [highlighted]="false"></app-plan>
  <app-plan planType="NonMaturityDepositsStandard" [highlighted]="false"></app-plan>
</div>


<!-- <div class="signup-wrap">
  <div class="signup-wrap__inner">
    <div class="signup signupTemporal">
      <div class="signup__intro signup__introTemporal">
        <h2 class="signup__intro-title">Plans Available for Every Strategy</h2>
        <p class="signup__intro-text">Whether you are looking to start a new line of business, invest in an innovative marketing strategy, or evaluate your financial institution’s performance, Lakehouse Analytics will give you the data you need to make effective decisions.</p>
        <a class="signup__more" href="https://lakehouse-analytics.com/solutions/peer-comparison/" target="_blank">
        Learn More</a>
      </div>
      <app-plan class="test_temporal" planType="PeerComparisonStandard" [highlighted]="true"></app-plan>
      <app-plan planType="PeerComparisonBasic"></app-plan>
    </div>
  </div>
</div> -->